import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CompanyProvider } from '@lighty';
import { StorageService } from '@services';

/**
 * Documentacion de la Client API: solo administradores u owner de la compania (decision del
 * 2026-10-01: todos los administradores, tenga o no credenciales de API). api-2 lo vuelve a
 * comprobar y responde 403; esto solo evita mostrar una pantalla vacia.
 */
@Injectable({ providedIn: 'root' })
export class ClientApiDocsGuard implements CanActivate {

    constructor(
        private router: Router,
        private storageService: StorageService,
        private companyProvider: CompanyProvider,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const company: any = this.storageService.get('company');
        const slug = this.getSlug(route) || company?.slug;
        const fallback = slug
            ? this.router.createUrlTree(['/learn', slug])
            : this.router.createUrlTree(['/login']);

        if (!slug) {
            return of(fallback);
        }

        // Los guards corren antes que los resolvers del route padre: los roles se piden aqui.
        return this.companyProvider.getRoles(slug).pipe(
            map((access: any) => access?.roles?.companyAdministrator || access?.roles?.companyOwner
                ? true
                : fallback),
            catchError(() => of(fallback)),
        );
    }

    /** El slug vive en el route padre `:slug`; se busca subiendo por la jerarquia. */
    private getSlug(route: ActivatedRouteSnapshot): string | null {
        let snap: ActivatedRouteSnapshot | null = route;
        while (snap) {
            const slug = snap.paramMap.get('slug');
            if (slug) { return slug; }
            snap = snap.parent;
        }
        return null;
    }
}
